import { DataGrid, mergeSx, useTheme, type DataGridProps } from '@shared/components';
import { useMediaQuery } from '@shared/hooks';

import RegistrationExamineesNoRowsOverlay from './registration-examinees-data-grid-no-rows-overlay';

export type RegistrationExamineesDataGridProps = DataGridProps;

export default function RegistrationExamineesDataGrid(
  props: Readonly<RegistrationExamineesDataGridProps>,
) {
  const { rows, sx, ...restProps } = props;

  const theme = useTheme();
  const isTabletOrDesktop = useMediaQuery(theme.breakpoints.up('tablet'));

  return (
    <DataGrid
      {...restProps}
      disableColumnMenu
      rows={rows}
      hideFooter={rows.length === 0}
      rowHeight={isTabletOrDesktop ? 48 : 152}
      sx={mergeSx(
        (theme) => ({
          overflowX: 'scroll',
          '--DataGrid-overlayHeight': '124px',
          border: `1px solid ${theme.palette.grey[300]}`,
          backgroundColor: theme.palette.background.paper,
          '.MuiDataGrid-cell': {
            p: theme.spacing(3),
          },
          '.MuiDataGrid-columnHeaders': {
            backgroundColor: theme.palette.grey[100],
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
          },
          '.MuiDataGrid-columnHeader': {
            p: theme.spacing(3),
          },
          '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
          },
          '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
            display: 'none',
            [theme.breakpoints.up('tablet')]: {
              display: 'block',
            },
          },
          '& .MuiTablePagination-input': {
            display: 'none',
            [theme.breakpoints.up('tablet')]: {
              display: 'inline-flex',
            },
          },
          // Style override for Footer
          '> .MuiBox-root': {
            p: theme.spacing(3, 4),
            '& .MuiToolbar-root': {
              minHeight: 'unset',
              height: 'unset',
              '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                m: 0,
              },
              '& .MuiTablePagination-actions': {
                ml: theme.spacing(1),
                '> button': {
                  p: theme.spacing(1),
                },
              },
            },
          },
        }),
        sx,
      )}
      slots={{
        noRowsOverlay: RegistrationExamineesNoRowsOverlay,
      }}
    />
  );
}
